import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for License
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const SUBMISSION_CC_LICENSE = new ResourceType('submissioncclicense');
